export default __webpack_public_path__ + "static/lauschtour-0787cff03b583a819338c91969bdcfa8.png";